
export enum JobOriginIds{
    staffline = "dba8510d-cf96-4d06-97d1-fb216a790f61",
    jobRialto = "35831246-c190-43d6-9202-0b83c041b38f"
}